export const TYPE_OF_POLL_PLACEHOLDER = {
  satisfactionTitle: 'Ex. Qual a sua opinião sobre o serviço de hoje?',
  satisfactionTitleDescription: 'Ex. Opinião sobre o serviço de hoje',
  satisfactionLabel: 'Deixe seu comentário',
  satisfactionTextField: 'Ex. Gosto muito da sobremesa...',
  satisfactionSelection: 'Ex. Relevância dos resultados',
  reservationTitle: 'Digite um título para a pergunta de reserva',
  reservationTitleDescription: 'Digite a descrição do título da pergunta de reserva',
  reservationLabel: 'Digite aqui sua resposta',
  reservationTextField: 'Digite aqui....',
  reservationSelection: 'Digite o conteúdo do item',
}
